/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgencyContactDto } from '../../models/agency-contact-dto';

export interface ApiAgencycontactAgencyAgencyGuidGet$Params {
  agencyGuid: string;
  'api-version'?: string;
}

export function apiAgencycontactAgencyAgencyGuidGet(http: HttpClient, rootUrl: string, params: ApiAgencycontactAgencyAgencyGuidGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgencyContactDto>>> {
  const rb = new RequestBuilder(rootUrl, apiAgencycontactAgencyAgencyGuidGet.PATH, 'get');
  if (params) {
    rb.path('agencyGuid', params.agencyGuid, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgencyContactDto>>;
    })
  );
}

apiAgencycontactAgencyAgencyGuidGet.PATH = '/api/agencycontact/agency-{agencyGuid}';
